import { put, select, call, takeLatest } from 'redux-saga/effects'
import { IAuthorizationInformationState } from '../store/authorizationInformation.types'
import { AuthorizationInformationConstants } from '../store/authorizationInformation.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getAuthorizationInformationSelector } from '../selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveAuthorizationInformation() {
  const authorizationInformation: IAuthorizationInformationState = yield select(getAuthorizationInformationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      billing: {
        ...pcrDoc.billing,
        authorizationInformation,
      },
    }
    try {
      yield put(setHasPatient(true))
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveAuthorizationInformation() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* saveAuthorizationInformationSaga() {
  yield takeLatest(
    [AuthorizationInformationConstants.SAVE_AUTHORIZATIONINFO],
    performWithMutexHOG,
    saveAuthorizationInformation
  )
}
